<template>
    
    
    <div>
        <div class="row">
            <div class="col-8 pl-3">
                <h5 class="h5 text-capitalize">{{ __('forms.RecruitingApplicant.tab_interview-sheets') }}</h5>
                <div class="step-divider"></div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-personal-evaluation">
                        <thead>
                            <tr>
                                <th>{{ __('forms.MeritMatrixExecuted.year') }}</th>
                                <th>{{ __('forms.RecruitingChart.campaign') }}</th>
                                <th>{{ __('forms.forms.HrtJobExecutionLog.Status') }}</th>
                                <th>{{ __('forms.EvaluationChart.questions.questions_setting.xlsx.questions.question17.date') }}</th>
                                <th>{{ __('misc.actions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row,index) in list_charts" :key="index">
                                <td>{{ row.campaign_data.started_at.split("-")[0] }}</td>
                                <td>{{ row.campaign }}</td>
                                <td>{{ row.status }}</td>
                                <td>{{ row.chartCreatedAt }}</td>
                                <td>
                                    <button type="button" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history" @click="openChart(index)"><i class="fas fa-eye"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>

    export default {

        data () {
            return {
                list_charts : []
            }
        },
        methods: {
            openChart(index){
                window.open("/recruiting-charts/"+index,"_blank");
            }
        },
        mounted() {


            axios.get("/recruiting-applicants-charts/"+this.person_id)
                .then((response) => {
                    this.list_charts  = response.data;
                });
        },
        props: {
          person_id : Number
        }

    }
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .con-vs-popup {
    z-index: 1000;
  }
</style>
